import { type AxiosResponse } from 'axios'
import { type IResponseOutboundSource } from 'entities/OutboundSource/api/types'
import { baseApi } from 'entities/Auth'
import type { IMessagingStatisticResponse, IMessagingChartResponse } from './types'
import { BaseAnalyticsApi } from './baseAnalyticsApi'

class MessagesApi extends BaseAnalyticsApi<IMessagingStatisticResponse, IMessagingChartResponse> {
  constructor() {
    super('messages')
  }

  getOutboundSources(): Promise<AxiosResponse<IResponseOutboundSource[]>> {
    return baseApi.get('analytics/analytics/messages/sources')
  }
}

export const MessagesAnalyticsApi = new MessagesApi()
